import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/manrope';
import '@fontsource-variable/cormorant-garamond';
import { App } from './App';
import './styles.css';
import './hero-entrance.css';
import './opening-cards.css';
import './product-story.css';
import './scroll-showcase.css';
import './refinements.css';
import './product-experience.css';
import './journey-motion.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
